// ResponsiveContext.tsx
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";

type ResponsiveContextType =
  | {
      isDesktop: boolean;
      isMobile: boolean;
    }
  | undefined;

const ResponsiveContext = createContext<ResponsiveContextType>(undefined);

// Mobile menu context
type MobileMenuContextType = {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
} | undefined;

const MobileMenuContext = createContext<MobileMenuContextType>(undefined);

export const ResponsiveProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 500);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
      setIsMobile(window.innerWidth < 500);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ResponsiveContext.Provider value={{ isDesktop, isMobile }}>
      <MobileMenuContext.Provider value={{ isMobileMenuOpen, setIsMobileMenuOpen }}>
      {children}
      </MobileMenuContext.Provider>
    </ResponsiveContext.Provider>
  );
};

export const useResponsive = () => {
  const context = useContext(ResponsiveContext);
  if (context === undefined) {
    throw new Error("useResponsive must be used within a ResponsiveProvider");
  }
  return context;
};

export const useMobileMenu = () => {
  const context = useContext(MobileMenuContext);
  if (context === undefined) {
    throw new Error("useMobileMenu must be used within a ResponsiveProvider");
  }
  return context;
};
